/* Add shopping exits without changing the published research or product availability. */
(() => {
 const root = document.querySelector('[data-ploy-page="science"]');
 if (!root) return;
 const products = new Map();
 function productActions() {
  for (const link of root.querySelectorAll('#formulation a[href^="/products/"]')) {
   const match = link.textContent.trim().match(/^Explore the (Serum|Cream|Stick)$/i);
   if (!match || link.dataset.scienceShop) continue;
   link.dataset.scienceShop = 'true';
   const name = match[1].toUpperCase();
   link.textContent = 'SHOP THE ' + name;
   link.classList.add('science-product-shop');
   link.parentElement.classList.add('science-product-actions');
   const form = document.createElement('form');
   form.className = 'science-product-cart';
   form.method = 'post';
   const route = window.Shopify?.routes?.root || '/';
   form.action = route + 'cart/add';
   const button = document.createElement('button');
   button.type = 'submit';button.textContent = 'ADD TO CART';button.disabled = true;
   button.setAttribute('aria-label', 'Add the ' + match[1] + ' to cart');
   form.append(button);link.after(form);
   const url = link.getAttribute('href') + '.js';
   if (!products.has(url)) products.set(url, fetch(url).then(response => {
    if (!response.ok) throw new Error('Product unavailable');
    return response.json();
   }));
   products.get(url).then(product => {
    const variant = product.variants.find(item => item.available);
    if (!variant) {button.textContent = 'SOLD OUT';return;}
    for (const [name,value] of [['id',variant.id],['quantity','1'],['return_to',route+'cart']]) {
     const input = document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.append(input);
    }
    button.disabled=false;
   }).catch(() => {button.textContent='UNAVAILABLE';});
   form.addEventListener('submit', () => {button.disabled=true;button.textContent='ADDING…';});
  }
 }
 function enhance() {
  productActions();
  for (const [selector,label,href] of [
   ['#how-ghk-cu-works > .koppa-container','Explore the three formulas','#formulation'],
   ['#research > .koppa-container','Explore the GHK-Cu Protocol','/products/ghk-cu-trio'],
   ['#faq > .koppa-container','Find your formula','/pages/find-your-routine']
  ]) {
   const container=root.querySelector(selector);
   if (!container || container.querySelector('.science-action-row')) continue;
   const row=document.createElement('div');row.className='science-action-row';
   const link=document.createElement('a');link.className='science-shop-cta';link.href=href;link.textContent=label+' →';
   row.append(link);container.append(row);
  }
  const faq = root.querySelector('#faq > .koppa-container');
  if (faq) {
   const accordion = Array.from(faq.children).find(item => item.querySelector('details'));
   const supplemental = document.querySelector('.koppa-exact-faq[data-koppa-phrase-group="science"]');
   if (accordion && supplemental) {
    const questions = supplemental.querySelector('.koppa-exact-faq__questions');
    const heading = supplemental.querySelector('h2');
    if (questions && heading) {
     const more = document.createElement('details');
     more.className = 'science-more-questions';
     const summary = document.createElement('summary');
     summary.textContent = heading.textContent.trim();
     more.append(summary, questions);
     accordion.append(more);
     supplemental.remove();
    }
   }
   const action = faq.querySelector('.science-action-row');
   if (accordion && action && action.parentElement !== accordion) accordion.append(action);
  }
  const table=root.querySelector('#formula-comparison table');
  if(table && !root.querySelector('.science-scroll-hint')) {
   const hint=document.createElement('p');hint.className='science-scroll-hint';hint.id='science-comparison-hint';hint.textContent='Swipe to compare the three formulas →';
   table.parentElement.before(hint);table.parentElement.tabIndex=0;table.parentElement.setAttribute('role','region');table.parentElement.setAttribute('aria-label','Compare the three formulas');
  }
 }
 enhance();new MutationObserver(enhance).observe(root,{childList:true,subtree:true});
})();

